<!-- <router-outlet></router-outlet> -->

<div id="top" class="page logo-container">
  <div>
    <h1 title="IT-ERA">
      <img src="/assets/logo-noborder.svg" alt="Logo IT-era" />
    </h1>

    La route du web
  </div>

  <div class="scroll-link" (click)="scroll(main)" (touchend)="scroll(main)">
    <svg
      class="mouse"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 76 130"
      preserveAspectRatio="xMidYMid meet"
    >
      <g fill="none" fill-rule="evenodd">
        <rect
          width="70"
          height="118"
          x="1.5"
          y="1.5"
          stroke-width="3"
          rx="36"
        />
        <circle class="scroll" cx="36.5" cy="31.5" r="4.5" />
      </g>
    </svg>
  </div>
</div>

<div id="main" class="page dictionary-container" #main>
  <div class="">
    <div class="dictionary-entry">
      <label class="word">iter, itineris</label>, n.
      <span class="lang">(latin)</span>
      <dfn>chemin qu'on fait, trajet, voyage.</dfn>
    </div>

    <div class="dictionary-entry">
      <label class="word">iteration</label>, nf.
      <span class="lang">(français)</span>
      <dfn
        >1. action de répéter la même action sur tout un ensemble, ou résultat
        de cette action.</dfn
      >
      <dfn
        >2. en informatique, procédé de calcul répétitif qui boucle jusqu'à ce
        qu'une condition particulière soit remplie.</dfn
      >
    </div>

    <div class="dictionary-entry">
      <label class="word">I.T. era</label>, abrv.
      <span class="lang">(010101)</span>
      <dfn>1. ère des Technologies de l'Information.</dfn>
      <dfn>2. cette entreprise \o/</dfn>
    </div>
  </div>
</div>

<div id="bottom" class="page contact-container" #contact>
  <div class="contact-left">
    <div>
      <br />Depuis son lancement en, IT-era intervient auprès d'entreprises afin de
      les accompagner dans le développement de solutions logicielles métiers.
      <br />
      <br />Notre expertise des dernières technologies web nous permet
      d'intervenir sur toutes sortes d'architectures et de besoins.
      <br />
      <br />Lancez-vous, prenez contact avec nous.
      <br />
    </div>
  </div>
  <div class="contact-right">
    <div>
      <div>
      <span>
        <img src="/assets/logo-white.png" alt="IT-era" />
        <br />
        <a class="middle" href="mailto:contact@it-era.dev" target="_top"
          >contact&#64;it-era.dev</a
        >
      </span>
      <br /><a class="middle" href="tel:0632526275" target="_top"
        >06&nbsp;32&nbsp;52&nbsp;62&nbsp;75</a
      >
      </div>
    </div>
  </div>
</div>
